export const quizList = ({store}) => store.quizReducer.data;
export const quizLoading = ({store}) => store.quizReducer.loading;
export const quizError = ({store}) => store.quizReducer.error;